import { render } from "./SkeletonPaymentDetails.vue?vue&type=template&id=62a57c7a"
import script from "./SkeletonPaymentDetails.vue?vue&type=script&lang=js"
export * from "./SkeletonPaymentDetails.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__